import axios_instance from '../utilities/axios_instance';

const API = process.env.REACT_APP_API_URL;

const PhoneVerificationService = {
  start: async (phoneNumber) => {
    const URL = `${API}verify/phone/start`;
    const response = await axios_instance.post(`${URL}`, { phoneNumber });
    return response.data?.data || response.data;
  },

  check: async (phoneNumber, code) => {
    const URL = `${API}verify/phone/check`;
    const response = await axios_instance.post(`${URL}`, { phoneNumber, code });
    return response.data?.data || response.data;
  },
};

export default PhoneVerificationService;
